/**
 * Formatting utilities for dates, timestamps, and other display values
 */

export const formatTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${day} ${month} ${year} ${hours}:${minutes}`;
};

export const formatAppointmentDateTime = (date: string, time: string): string => {
  const appointmentDate = new Date(`${date}T${time}`);
  const day = appointmentDate.getDate().toString().padStart(2, '0');
  const month = appointmentDate.toLocaleDateString('en-US', { month: 'short' });
  const year = appointmentDate.getFullYear();
  const hours = appointmentDate.getHours().toString().padStart(2, '0');
  const minutes = appointmentDate.getMinutes().toString().padStart(2, '0');
  
  return `${day} ${month} ${year} ${hours}:${minutes}`;
};

export const getStatusClass = (status: string): string => {
  // Dynamic: derive CSS class from kebab-case status slug
  const slug = status.trim().replace(/\s+/g, '-').toLowerCase();
  return `status-${slug}`;
};

export const formatStatusDisplay = (status: string): string => {
  return status.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase());
};